import axiosInstance from './axiosConfig';

export interface NewVisitForm {
  _id?: string;
  userId: string;
  status: 'pending' | 'inProgress' | 'submitted';
  submittedAt?: string | null;
  formQuestionnaire?: { data: Record<string, unknown> };
}

export interface FollowUpForm {
  _id?: string;
  id?: number;
  userId?: string;
  status: 'pending' | 'inProgress' | 'submitted';
  submittedAt?: string | null;
  updatedAt?: string;
  formData?: Record<string, unknown>;
}

export const getNewVisit = (userId: string) =>
  axiosInstance.get<{ result: { form: NewVisitForm | null } }>(
    `/forms/admin/${userId}/new-visit`
  );

export const getAllFollowUps = (userId: string) =>
  axiosInstance.get<{ result: { forms: FollowUpForm[] } }>(
    `/forms/admin/${userId}/followup/all`
  );

export const getFollowUpById = (userId: string, formId: string) =>
  axiosInstance.get<{ result: { form: FollowUpForm | null } }>(
    `/forms/admin/${userId}/followup/${formId}`
  );

export type NewVisitFormOverride = 'show' | 'hide';

export interface NewVisitFormStatus {
  status: 'submitted' | 'not_submitted' | 'not_found';
  submittedAt?: string | null;
  shouldShowForm: boolean;
  override: NewVisitFormOverride | null;
}

export const getNewVisitStatus = (userId: string) =>
  axiosInstance.get<{ result: NewVisitFormStatus }>('/forms/new-visit-status', {
    params: { userId },
  });

export const setNewVisitVisibility = (
  userId: string,
  override: NewVisitFormOverride | null
) =>
  axiosInstance.post<{ result: { override: NewVisitFormOverride | null } }>(
    `/forms/admin/${userId}/new-visit/visibility`,
    { override }
  );

export const reopenNewVisit = (userId: string) =>
  axiosInstance.post<{ result: { form: NewVisitForm } }>(
    `/forms/admin/${userId}/new-visit/reopen`
  );
